import DataFieldCache from "@/models/data.field.cache";
import {currentUserModule} from "@/store";
import {MdbsCore} from "@/api/tsclient";
import Rights = MdbsCore.Rights;

const EventReportTypeFieldDefinitionId: string = "ce927be3-e4cc-420e-bb9c-37a2665dc064";
const EventReportInitialType: string = "initialReport";

export const eventReportIsInitial = function (eventReportField: DataFieldCache) {
    let reportTypeField = eventReportField.childFields.traverse(child => child.childFields ?? []).find(field => field.definitionId == EventReportTypeFieldDefinitionId)
    if (reportTypeField == undefined)
        return true;

    let reportType = reportTypeField.values.value ?? "";
    return reportType == EventReportInitialType;
}

export const canDeactivateEventReports = function () {
    return currentUserModule.hasRight(Rights.EventReportDeactivationCmd);
}

export const canDeleteEvents = function () {
    return currentUserModule.hasRight(Rights.InstrumentDataFieldDeleteCmd);
}

export const canSignEventReports = function () {
    return currentUserModule.hasRight(Rights.EventReportSignatureCmd);
}
